import axios from 'axios';
import { getLoggedInUser } from './authUtils';
import { memoizedGetNewToken } from './refresh';
import { store } from '../index';
import { userUpdated } from '../redux/auth/actions';
import { Cookies } from 'react-cookie';

const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL,
    method: 'get',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
};

class AxiosApi {
    constructor(history) {
        this.history = history;

        this.axios = axios.create(defaultOptions);

        this.axios.interceptors.request.use(async (config) => {
            await memoizedGetNewToken();
    
            return config;
        });
        // Set the AUTH token for any request
        this.axios.interceptors.request.use(function (config) {
            const user = getLoggedInUser();
            const token = user ? user.token : null;

            if(token) {
                config.headers.Authorization = `Bearer ${token}`;
            }            

            const cookies = new Cookies();
            const csrftoken = cookies.get('csrftoken');

            if(csrftoken) {
                config.headers['X-CSRFToken'] = csrftoken;
            }

            return config;
        });
    
        this.axios.interceptors.response.use((response) => {
            return response
        }, (error) => {
            switch (error?.response?.status) {
                case 401:
                    store.dispatch(userUpdated(null));
                    window.location.href = '/account/login';
                    break;
                case 403:
                    if(error.response.data?.detail?.includes('MFA')) {
                        this.history.push('/account/mfa-code');
                    }                    
                    break;
            
                default:
                    break;
            }
            return Promise.reject(error);
        });
    }
}

export { AxiosApi };